import { Pipe, PipeTransform } from '@angular/core';
import { BaseImagePipe } from './base-image.pipe';
import { environment as ENV } from '@environment';


@Pipe({
  name: 'ImageCdn',
  standalone: false
})
export class ImageCdnPipe extends BaseImagePipe implements PipeTransform {
  
  private baseAssets: string = ENV.resources.base_lambda_img.replace('/web', '');
  
  transform(value: string, dimension?: string): string {
    super.setBaseUrl(this.baseAssets);
    return super.transform(value.split('/').join('_'), 'web/travel', dimension);
  }
  
  public baseImage(value: string, folder: string, dimension?: string, extension?: string, quality?: string): string {
    return super.transform(value, folder, dimension, extension, quality);
  }
} 
